import { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import CourseDropdown from "./CourseDropdown";

const DesktopNavbar = ({ navLinks, onContactClick, isScrolled, isOverLightSection }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navRef = useRef(null);

  const handleLinkClick = (e, href, linkName) => {
    console.log("Desktop link clicked:", linkName, href);

    if (linkName === "Contact Us") {
      e.preventDefault();
      onContactClick();
    } else if (href === "#business") {
      e.preventDefault();
      setTimeout(() => {
        document
          .getElementById("business")
          ?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const navbarClasses = `w-full border-b font-fira-sans transition-all duration-300 ${
    isOverLightSection
      ? "bg-[#08090A] border-black/20"
      : "border-white/20 " + (isScrolled ? "backdrop-blur-[34px] bg-black/30" : "bg-transparent")
  }`;

  return (
    <div className={navbarClasses}>
      <div className="gutter-x" ref={navRef}>
        <nav>
          <div className="px-4 md:px-6">
            <div className="flex items-center justify-between h-16 md:h-20">
              <div className="flex items-center">
                <img
                  src="/home/osnewsvg.svg"
                  alt="Outskill"
                  width="144"
                  height="24"
                  className="h-6 w-auto cursor-pointer"
                  onClick={() => (window.location.href = "/")}
                />
              </div>

              <div className="flex items-center space-x-8">
                {navLinks.map((link, index) => (
                  <a
                    key={index}
                    href={link.href}
                    onClick={(e) => handleLinkClick(e, link.href, link.name)}
                    onMouseDown={() => console.log("Mouse down on:", link.name)}
                    className="text-white/50 text-base font-normal px-3 py-2 cursor-pointer relative z-10"
                    {...(link.href.startsWith("http")
                      ? {
                          target: "_blank",
                          rel: "noopener noreferrer",
                        }
                      : {})}
                  >
                    {link.name}
                  </a>
                ))}
              </div>

              <div className="flex items-center space-x-4">
                <a
                  href="https://platform.outskill.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hidden md:block text-white/50 hover:text-white hover:bg-white/10 w-[120px] font-normal text-base px-4 py-3 rounded-[2px] transition-all duration-200"
                >
                  Log in
                </a>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsDropdownOpen(!isDropdownOpen);
                  }}
                  className="bg-white hover:bg-[#ffffff]/30 hover:text-white text-black font-medium px-6 py-3 rounded-[2px] transition-all duration-200 text-base text-center inline-block"
                >
                  Explore Courses
                </button>
              </div>
            </div>

            {/* Desktop Dropdown */}
            {isDropdownOpen && (
              <CourseDropdown
                onClose={() => setIsDropdownOpen(false)}
                variant="desktop"
              />
            )}
          </div>
        </nav>
      </div>
    </div>
  );
};

DesktopNavbar.propTypes = {
  navLinks: PropTypes.array.isRequired,
  onContactClick: PropTypes.func.isRequired,
  isScrolled: PropTypes.bool.isRequired,
  isOverLightSection: PropTypes.bool,
};

export default DesktopNavbar;
